import { loginResponseData } from "../../types/login";

export const SET_LOGIN = "SET_LOGIN" as const;
export const SET_LOGOUT = "SET_LOGOUT" as const;
export const DASHBOARDKEYSEARCH = "DASHBOARDKEYSEARCH" as const;
export const SET_FINANCIAL_YEAR = "SET_FINANCIAL_YEAR" as const;

export interface SetLoginAction {
  type: typeof SET_LOGIN;
  payload: loginResponseData;
}

export interface SetLogoutAction {
  type: typeof SET_LOGOUT;
  payload: React.ReactNode;
}
